<template>
    <div class="el-row">
        <div class="card-deal-header deals-list-header caption-block">
            <div class="title">
                Список сделок
            </div>
            <transition name="slide-in">
                <column-settings v-if="columnSettingsShow" :columns-model="columnsModel" :attributes="attributes" />
            </transition>
            <transition name="slide-in">
                <filter-settings
                    v-show="filterSettingsShow"
                    :filter="filterModel"
                    :attributes="attributes"
                    @filterApplied="filterApplied"
                    @get-filter-title="getFilterTitle"
                />
            </transition>
            <div class="actions deals-menu">
                <div class="filter icon-filter icon" @click="filterSettingsShow = !filterSettingsShow"></div>
                <div class="icon-settings icon" @click="columnSettingsShow = !columnSettingsShow"></div>
                <div class="add-deal icon-plus icon"></div>
                <div class="messages icon-msg icon">
                    <div class="msg-count">
                        {{ this.unreadDeals }}
                    </div>
                </div>
            </div>
        </div>
        <div class="deals-info">
            <div class="row" v-if="filterTitle">
                <div class="label">
                    Фильтрация:
                </div>
                <div class="value">
                    {{ filterTitle }}
                </div>
            </div>
            <div class="row">
                <div class="label">
                    Всего найдено:
                </div>
                <div class="value">
                    {{ pagesInfo.total }} сделок на сумму {{ pagesInfo.amount }} р.
                </div>
            </div>
        </div>
        <div class="deals-wrapper deals-list mobile-wrapper" v-if="this.deals && this.deals.length">
            <div class="card-deal card" v-for="deal in deals" :key="deal.id" @click="goToDeal(deal.id)">
                <div class="card-deal-caption row">
                    <div class="title" v-if="!attributes.id.hide">
                        {{ attributes.id.name }} {{ deal.id ? deal.id : '' }}
                    </div>
                    <div class="unread-msg" v-if="!attributes.unread_messages.hide && deal.unread_messages">
                        <div class="icon-msg orange icon"></div>
                        <div class="msg-count">
                            {{ deal.unread_messages ? deal.unread_messages : '' }}
                        </div>
                    </div>
                </div>
                <div class="row" v-if="!attributes.title.hide">
                    <div class="label">
                        {{ attributes.title.name }}:
                    </div>
                    <div class="value">
                        {{ deal.title }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.created_at.hide">
                    <div class="label">
                        {{ attributes.created_at.name }}:
                    </div>
                    <div class="value">
                        {{ deal.created_at ? deal.created_at : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.contact_name.hide">
                    <div class="label">
                        {{ attributes.contact_name.name }}:
                    </div>
                    <div class="value">
                        {{ deal.contact ? deal.contact.name : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.contact_phone.hide">
                    <div class="label">
                        {{ attributes.contact_phone.name }}:
                    </div>
                    <div class="value">
                        {{ deal.contact ? deal.contact.phone : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.contact_email.hide">
                    <div class="label">
                        {{ attributes.contact_email.name }}:
                    </div>
                    <div class="value">
                        {{ deal.contact ? deal.contact.email : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.custom_fields.hide">
                    <div class="label">
                        {{ attributes.custom_fields.name }}:
                    </div>
                    <div class="value">
                        {{ viewCustomFields(deal.custom_fields) }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.address.hide">
                    <div class="label">
                        {{ attributes.address.name }}:
                    </div>
                    <div class="value">
                        {{ deal.address }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.status.hide">
                    <div class="label">
                        {{ attributes.status.name }}:
                    </div>
                    <div class="value">
                        {{ deal.status ? deal.status.name : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.measurer_user.hide">
                    <div class="label">
                        {{ attributes.measurer_user.name }}:
                    </div>
                    <div class="value">
                        {{ deal.measurer_user ? deal.measurer_user.full_name : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.measurement_date.hide">
                    <div class="label">
                        {{ attributes.measurement_date.name }}:
                    </div>
                    <div class="value">
                        {{ deal.measurement_date ? deal.measurement_date : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.measurement_time.hide">
                    <div class="label">
                        {{ attributes.measurement_time.name }}:
                    </div>
                    <div class="value">
                        {{ deal.measurement_time ? deal.measurement_time : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.responsible_user.hide">
                    <div class="label">
                        {{ attributes.responsible_user.name }}:
                    </div>
                    <div class="value">
                        {{ deal.responsible_user ? deal.responsible_user.full_name : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.office.hide">
                    <div class="label">
                        {{ attributes.office.name }}:
                    </div>
                    <div class="value">
                        {{ deal.responsible_user ? deal.responsible_user.office_name : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.contract_number.hide">
                    <div class="label">
                        {{ attributes.contract_number.name }}:
                    </div>
                    <div class="value">
                        {{ deal.contract_number ? deal.contract_number : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.contract_date.hide">
                    <div class="label">
                        {{ attributes.contract_date.name }}:
                    </div>
                    <div class="value">
                        {{ deal.contract_date ? deal.contract_date : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.budget.hide">
                    <div class="label">
                        {{ attributes.budget.name }}:
                    </div>
                    <div class="value">
                        {{ deal.budget ? deal.budget : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.link.hide">
                    <div class="label">
                        {{ attributes.link.name }}:
                    </div>
                    <div class="value">
                        {{ deal.link ? deal.link.name : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.volume.hide">
                    <div class="label">
                        {{ attributes.volume.name }}:
                    </div>
                    <div class="value">
                        {{ deal.volume ? deal.volume : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.square_m2.hide">
                    <div class="label">
                        {{ attributes.square_m2.name }}:
                    </div>
                    <div class="value">
                        {{ deal.square_m2 ? deal.square_m2 : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.finish.hide">
                    <div class="label">
                        {{ attributes.finish.name }}:
                    </div>
                    <div class="value">
                        {{ deal.finish ? booleanFormat(deal.finish) : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.finish_amount.hide">
                    <div class="label">
                        {{ attributes.finish_amount.name }}:
                    </div>
                    <div class="value">
                        {{ deal.finish_amount ? deal.finish_amount : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.profile_type.hide">
                    <div class="label">
                        {{ attributes.profile_type.name }}:
                    </div>
                    <div class="value">
                        {{ deal.profile_type ? deal.profile_type.name : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.jalousie.hide">
                    <div class="label">
                        {{ attributes.jalousie.name }}:
                    </div>
                    <div class="value">
                        {{ deal.jalousie ? booleanFormat(deal.jalousie) : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.jalousie_amount.hide">
                    <div class="label">
                        {{ attributes.jalousie_amount.name }}:
                    </div>
                    <div class="value">
                        {{ deal.jalousie_amount ? deal.jalousie_amount : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.promising_customer.hide">
                    <div class="label">
                        {{ attributes.promising_customer.name }}:
                    </div>
                    <div class="value">
                        {{ deal.promising_customer ? booleanFormat(deal.promising_customer) : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.to_production.hide">
                    <div class="label">
                        {{ attributes.to_production.name }}:
                    </div>
                    <div class="value">
                        {{ deal.to_production ? booleanFormat(deal.to_production) : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.difficult_metering.hide">
                    <div class="label">
                        {{ attributes.difficult_metering.name }}:
                    </div>
                    <div class="value">
                        {{ deal.difficult_metering ? booleanFormat(deal.difficult_metering) : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.refuse_before_metering.hide">
                    <div class="label">
                        {{ attributes.refuse_before_metering.name }}:
                    </div>
                    <div class="value">
                        {{ deal.refuse_before_metering ? booleanFormat(deal.refuse_before_metering) : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.tech_refusal.hide">
                    <div class="label">
                        {{ attributes.tech_refusal.name }}:
                    </div>
                    <div class="value">
                        {{ deal.tech_refusal ? booleanFormat(deal.tech_refusal) : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.re_measurement.hide">
                    <div class="label">
                        {{ attributes.re_measurement.name }}:
                    </div>
                    <div class="value">
                        {{ deal.re_measurement ? booleanFormat(deal.re_measurement) : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.re_measurement_date.hide">
                    <div class="label">
                        {{ attributes.re_measurement_date.name }}:
                    </div>
                    <div class="value">
                        {{ deal.re_measurement_date ? deal.re_measurement_date : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.re_measurement_time.hide">
                    <div class="label">
                        {{ attributes.re_measurement_time.name }}:
                    </div>
                    <div class="value">
                        {{ deal.re_measurement_time ? deal.re_measurement_time : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.measurer_bonus.hide">
                    <div class="label">
                        {{ attributes.measurer_bonus.name }}:
                    </div>
                    <div class="value">
                        {{ deal.measurer_bonus ? deal.measurer_bonus : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.conclusion.hide">
                    <div class="label">
                        {{ attributes.conclusion.name }}:
                    </div>
                    <div class="value">
                        {{ deal.conclusion_id ? deal.conclusion_id : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.start_production_date.hide">
                    <div class="label">
                        {{ attributes.start_production_date.name }}:
                    </div>
                    <div class="value">
                        {{ deal.start_production_date ? deal.start_production_date : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.discount.hide">
                    <div class="label">
                        {{ attributes.discount.name }}:
                    </div>
                    <div class="value">
                        {{ deal.discount ? deal.discount : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.prepay.hide">
                    <div class="label">
                        {{ attributes.prepay.name }}:
                    </div>
                    <div class="value">
                        {{ deal.prepay ? deal.prepay : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.pay_type.hide">
                    <div class="label">
                        {{ attributes.pay_type.name }}:
                    </div>
                    <div class="value">
                        {{ deal.pay_type ? deal.pay_type.name : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.installer_balance.hide">
                    <div class="label">
                        {{ attributes.installer_balance.name }}:
                    </div>
                    <div class="value">
                        {{ deal.installer_balance ? deal.installer_balance : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.in_production.hide">
                    <div class="label">
                        {{ attributes.in_production.name }}:
                    </div>
                    <div class="value">
                        {{ deal.in_production ? deal.in_production.name : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.production_cost.hide">
                    <div class="label">
                        {{ attributes.production_cost.name }}:
                    </div>
                    <div class="value">
                        {{ deal.production_cost ? deal.production_cost : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.jalousie_cost.hide">
                    <div class="label">
                        {{ attributes.jalousie_cost.name }}:
                    </div>
                    <div class="value">
                        {{ deal.jalousie_cost ? deal.jalousie_cost : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.finish_cost.hide">
                    <div class="label">
                        {{ attributes.finish_cost.name }}:
                    </div>
                    <div class="value">
                        {{ deal.finish_cost ? deal.finish_cost : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.garbage_removal.hide">
                    <div class="label">
                        {{ attributes.garbage_removal.name }}:
                    </div>
                    <div class="value">
                        {{ deal.garbage_removal ? deal.garbage_removal.name : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.delivery_date.hide">
                    <div class="label">
                        {{ attributes.delivery_date.name }}:
                    </div>
                    <div class="value">
                        {{ deal.delivery_date ? deal.delivery_date : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.installation_date.hide">
                    <div class="label">
                        {{ attributes.installation_date.name }}:
                    </div>
                    <div class="value">
                        {{ deal.installation_date ? deal.installation_date : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.installation_user.hide">
                    <div class="label">
                        {{ attributes.installation_user.name }}:
                    </div>
                    <div class="value">
                        {{ deal.installation_user ? deal.installation_user.full_name : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.installers_salary.hide">
                    <div class="label">
                        {{ attributes.installers_salary.name }}:
                    </div>
                    <div class="value">
                        {{ deal.installers_salary ? deal.installers_salary : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.installers_debt.hide">
                    <div class="label">
                        {{ attributes.installers_debt.name }}:
                    </div>
                    <div class="value">
                        {{ deal.installers_debt ? deal.installers_debt : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.additional_work.hide">
                    <div class="label">
                        {{ attributes.additional_work.name }}:
                    </div>
                    <div class="value">
                        {{ deal.additional_work ? deal.additional_work : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.complaint_opening_date.hide">
                    <div class="label">
                        {{ attributes.complaint_opening_date.name }}:
                    </div>
                    <div class="value">
                        {{ deal.complaint_opening_date ? deal.complaint_opening_date : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.complaint_amount.hide">
                    <div class="label">
                        {{ attributes.complaint_amount.name }}:
                    </div>
                    <div class="value">
                        {{ deal.complaint_amount ? deal.complaint_amount : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.complaint_materials_cost.hide">
                    <div class="label">
                        {{ attributes.complaint_materials_cost.name }}:
                    </div>
                    <div class="value">
                        {{ deal.complaint_materials_cost ? deal.complaint_materials_cost : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.guilty.hide">
                    <div class="label">
                        {{ attributes.guilty.name }}:
                    </div>
                    <div class="value">
                        {{ deal.guilty ? deal.guilty.name : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.culprit.hide">
                    <div class="label">
                        {{ attributes.culprit.name }}:
                    </div>
                    <div class="value">
                        {{ deal.culprit ? deal.culprit.name : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.complaint_performer.hide">
                    <div class="label">
                        {{ attributes.complaint_performer.name }}:
                    </div>
                    <div class="value">
                        {{ deal.complaint_performer ? deal.complaint_performer.name : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.specialist_payment.hide">
                    <div class="label">
                        {{ attributes.specialist_payment.name }}:
                    </div>
                    <div class="value">
                        {{ deal.specialist_payment ? deal.specialist_payment : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.complaint_closing_date.hide">
                    <div class="label">
                        {{ attributes.complaint_closing_date.name }}:
                    </div>
                    <div class="value">
                        {{ deal.complaint_closing_date ? deal.complaint_closing_date : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.roistat.hide">
                    <div class="label">
                        {{ attributes.roistat.name }}:
                    </div>
                    <div class="value">
                        {{ deal.roistat ? deal.roistat : '' }}
                    </div>
                </div>
            </div>
            <div class="pagination-wrapper">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="pagesInfo.total"
                    :page-size="pageModel.pageSize"
                    :current-page="pageModel.currentPage"
                    :pager-count="5"
                    @current-change="getCurrentPage"
                />
            </div>
            <ag-grid-vue
                class="fake-grid"
                :grid-options="gridOptions"
                :column-defs="columnDefs"
            />
        </div>
    </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import ColumnSettings from '@/components/ColumnSettingsMobile';
import FilterSettings from '@/components/FilterSettingsMobile';
import { eventBus } from '@/common/eventBus';
import defaultSettings from './defaultSettings';

const sortDefault = [
    {
        colId: 'id',
        sort: 'desc'
    }
];

export default {
    name: 'ListMobile',
    components: {
        ColumnSettings,
        FilterSettings,
        AgGridVue
    },
    data() {
        return {
            defaultSettings: defaultSettings,
            sortDefault: sortDefault,
            employer: null,
            columnSettingsShow: false,
            filterSettingsShow: false,
            filterTitle: null,
            attributes: {
                'id': {
                    value: null,
                    hide: false,
                    name: 'ID'
                },
                'unread_messages': {
                    value: [],
                    hide: false,
                    name: 'Непрочтённые сообщения'
                },
                'created_at': {
                    value: null,
                    hide: false,
                    name: 'Дата создания'
                },
                'tags': {
                    value: [],
                    hide: false,
                    name: 'Тэги'
                },
                'status': {
                    value: [],
                    hide: false,
                    name: 'Статус'
                },
                'status_id': {
                    value: [],
                    hide: true,
                    name: 'Статус',
                    notGridColumn: true
                },
                'responsible_user': {
                    value: [],
                    hide: false,
                    name: 'Ответственный'
                },
                'responsible_user_id': {
                    value: [],
                    hide: true,
                    name: 'Ответственный',
                    notGridColumn: true
                },
                'office': {
                    value: [],
                    hide: false,
                    name: 'Офис'
                },
                'office_id': {
                    value: [],
                    hide: true,
                    name: 'Офис',
                    notGridColumn: true
                },
                'contact_name': {
                    value: null,
                    hide: false,
                    name: 'Контакт'
                },
                'address': {
                    value: '',
                    hide: false,
                    name: 'Адрес'
                },
                'title': {
                    value: '',
                    hide: false,
                    name: 'Название'
                },
                'contact_id': {
                    value: null,
                    hide: true,
                    name: 'Контакт',
                    notGridColumn: true
                },
                'company_name': {
                    value: null,
                    hide: true,
                    notGridColumn: true
                },
                'contract_number': {
                    value: null,
                    hide: false,
                    name: 'Договор №'
                },
                'contract_date': {
                    value: null,
                    hide: false,
                    name: 'Дата договора'
                },
                'budget': {
                    value: null,
                    hide: false,
                    name: 'Бюджет'
                },
                'link': {
                    value: [],
                    hide: true,
                    name: 'Канал связи'
                },
                'link_id': {
                    value: [],
                    hide: true,
                    name: 'Канал связи',
                    notGridColumn: true
                },
                'volume': {
                    value: null,
                    hide: true,
                    name: 'Объем'
                },
                'square_m2': {
                    value: null,
                    hide: true,
                    name: 'Квадратура  м2'
                },
                'finish': {
                    value: null,
                    hide: true,
                    name: 'Отделка'
                },
                'profile_type': {
                    value: [],
                    hide: true,
                    name: 'Тип профиля'
                },
                'profile_type_id': {
                    value: [],
                    hide: true,
                    name: 'Тип профиля',
                    notGridColumn: true
                },
                'jalousie': {
                    value: null,
                    hide: true,
                    name: 'Жалюзи'
                },
                'promising_customer': {
                    value: null,
                    hide: true,
                    name: 'Перспективный заказчик'
                },
                'measurement_date': {
                    value: null,
                    hide: true,
                    name: 'Дата замера'
                },
                'measurer_user': {
                    value: [],
                    hide: true,
                    name: 'Замерщик'
                },
                'measurer_user_id': {
                    value: [],
                    hide: true,
                    name: 'Замерщик',
                    notGridColumn: true
                },
                'difficult_metering': {
                    value: null,
                    hide: true,
                    name: 'Сложный замер'
                },
                'measurer_bonus': {
                    value: null,
                    hide: true,
                    name: 'Бонус замерщика 1/2'
                },
                'conclusion': {
                    value: null,
                    hide: true,
                    name: 'Заключение'
                },
                'conclusion_id': {
                    value: null,
                    hide: true,
                    name: 'Заключение',
                    notGridColumn: true
                },
                'start_production_date': {
                    value: null,
                    hide: true,
                    name: 'Дата запуска в производство'
                },
                'discount': {
                    value: null,
                    hide: true,
                    name: 'Скидка'
                },
                'prepay': {
                    value: null,
                    hide: true,
                    name: 'Предоплата'
                },
                'pay_type': {
                    value: [],
                    hide: true,
                    name: 'Вид оплаты'
                },
                'pay_type_id': {
                    value: [],
                    hide: true,
                    name: 'Вид оплаты',
                    notGridColumn: true
                },
                'installer_balance': {
                    value: null,
                    hide: true,
                    name: 'Остаток по монтажу'
                },
                'in_production_id': {
                    value: [],
                    hide: true,
                    name: 'В производстве',
                    notGridColumn: true
                },
                'in_production': {
                    value: [],
                    hide: true,
                    name: 'В производстве'
                },
                'production_cost': {
                    value: null,
                    hide: true,
                    name: 'Сумма в производство себестоимость'
                },
                'jalousie_cost': {
                    value: null,
                    hide: true,
                    name: 'Себестоимость жалюзи'
                },
                'finish_cost': {
                    value: null,
                    hide: true,
                    name: 'Себестоимость отделки'
                },
                'garbage_removal': {
                    value: [],
                    hide: true,
                    name: 'Вывоз мусора'
                },
                'garbage_removal_id': {
                    value: [],
                    hide: true,
                    name: 'Вывоз мусора',
                    notGridColumn: true
                },
                'delivery_date': {
                    value: null,
                    hide: true,
                    name: 'Дата доставки'
                },
                'installation_date': {
                    value: null,
                    hide: true,
                    name: 'Дата монтажа'
                },
                'installation_user': {
                    value: [],
                    hide: true,
                    name: 'Монтажная бригада'
                },
                'installation_user_id': {
                    value: [],
                    hide: true,
                    name: 'Монтажная бригада',
                    notGridColumn: true
                },
                'installers_salary': {
                    value: null,
                    hide: true,
                    name: 'Зп монтажников'
                },
                'installers_debt': {
                    value: null,
                    hide: true,
                    name: 'Долг монтажников'
                },
                'additional_work': {
                    value: null,
                    hide: true,
                    name: 'Доп. работы'
                },
                'complaint_opening_date': {
                    value: null,
                    hide: true,
                    name: 'Дата открытия рекламации'
                },
                'complaint_amount': {
                    value: null,
                    hide: true,
                    name: 'Сумма рекламации'
                },
                'complaint_materials_cost': {
                    value: null,
                    hide: true,
                    name: 'Сумма материалов для рекламации'
                },
                'guilty': {
                    value: null,
                    hide: true,
                    name: 'Кто виноват'
                },
                'guilty_id': {
                    value: null,
                    hide: true,
                    name: 'Кто виноват',
                    notGridColumn: true
                },
                'complaint_performer': {
                    value: [],
                    hide: true,
                    name: 'Кто исправляет рекламацию'
                },
                'complaint_performer_id': {
                    value: [],
                    hide: true,
                    name: 'Кто исправляет рекламацию',
                    notGridColumn: true
                },
                'specialist_payment': {
                    value: null,
                    hide: true,
                    name: 'Оплата специалисту, который выполняет рекламацию'
                },
                'complaint_closing_date': {
                    value: null,
                    hide: true,
                    name: 'Дата закрытия рекламации'
                },
                'roistat': {
                    value: null,
                    hide: true,
                    name: 'Roistat'
                },
                'contact_phone': {
                    value: null,
                    hide: true,
                    name: 'Телефон'
                },
                'contact_email': {
                    value: null,
                    hide: true,
                    name: 'E-mail'
                },
                'culprit': {
                    value: [],
                    hide: true,
                    name: 'Виновник'
                },
                'culprit_id': {
                    value: [],
                    hide: true,
                    name: 'Виновник',
                    notGridColumn: true
                },
                'measurement_time': {
                    value: null,
                    hide: true,
                    name: 'Время замера'
                },
                'to_production': {
                    value: null,
                    hide: true,
                    name: 'В производство'
                },
                'refuse_before_metering': {
                    value: null,
                    hide: true,
                    name: 'ОДЗ'
                },
                'tech_refusal': {
                    value: null,
                    hide: true,
                    name: 'Тех отказ'
                },
                're_measurement': {
                    value: null,
                    hide: true,
                    name: 'Перезамер'
                },
                're_measurement_date': {
                    value: null,
                    hide: true,
                    name: 'Дата перезамера'
                },
                're_measurement_time': {
                    value: null,
                    hide: true,
                    name: 'Время перезамера'
                },
                'finish_amount': {
                    value: null,
                    hide: true,
                    name: 'Сумма отделки'
                },
                'jalousie_amount': {
                    value: null,
                    hide: true,
                    name: 'Сумма жалюзи'
                },
                'installation_done': {
                    value: null,
                    hide: true,
                    name: 'Монтаж выполнен'
                },
                'custom_fields': {
                    value: null,
                    hide: true,
                    name: 'Дополнительные поля'
                },
                '0': {
                    value: null,
                    hide: false,
                    name: 'Иконка настроек'
                }
            },
            columnsModel: [],
            filterModel: {
                id: null,
                created_at: {},
                tags: [],
                status_id: [],
                responsible_user_id: [],
                office_id: [],
                contact_id: [],
                contact_name: null,
                company_id: [],
                company_name: null,
                contract_number: null,
                contract_date: null,
                budget: null,
                link_id: [],
                volume: null,
                square_m2: null,
                finish: null,
                profile_type_id: [],
                jalousie: null,
                promising_customer: null,
                measurement_date: null,
                measurer_user_id: [],
                difficult_metering: null,
                measurer_bonus: null,
                conclusion_id: null,
                start_production_date: null,
                discount: null,
                prepay: null,
                pay_type_id: [],
                installer_balance: null,
                in_production_id: [],
                production_cost: null,
                jalousie_cost: null,
                finish_cost: null,
                garbage_removal_id: [],
                delivery_date: null,
                installation_date: null,
                installation_user_id: [],
                installers_salary: null,
                installers_debt: null,
                additional_work: null,
                complaint_opening_date: null,
                complaint_amount: null,
                complaint_materials_cost: null,
                guilty_id: null,
                complaint_performer_id: [],
                specialist_payment: null,
                complaint_closing_date: null,
                roistat: null,
                address: null,
                title: null,
                contact_phone: null,
                contact_email: null,
                culprit_id: [],
                measurement_time: null,
                to_production: null,
                refuse_before_metering: null,
                tech_refusal: null,
                re_measurement: null,
                re_measurement_date: null,
                re_measurement_time: null,
                finish_amount: null,
                jalousie_amount: null,
                custom_fields: null
            },
            pageModel: {
                currentPage: 1,
                pageSize: 20
            },
            columnDefs: [],
            gridOptions: {
                rowSelection: 'multiple',
                suppressDragLeaveHidesColumns: false,
                suppressPaginationPanel: true,
                suppressLoadingOverlay: true,
                rowDeselection: true,
                enableCellTextSelection: true,
                headerHeight: 50,
                rowHeight: 40,
                domLayout: 'autoHeight',
                defaultColDef: {
                    sortable: true,
                    filter: false,
                    resizable: true,
                    comparator: () => {
                        return 0;
                    },
                    cellClass: 'column-text'
                }
            },
            loading: true,
            unreadDeals: null
        };
    },
    computed: {
        deals() {
            return this.$store.state.deals.deals;
        },
        setting() {
            return this.$store.state.preferences.setting;
        },
        pagesInfo() {
            return this.$store.state.deals.pages;
        },
        sortModel() {
            const sort = this.sortDefault;
            if (this.employer) {
                if (this.employer.position_id === 2) {
                    sort[0].colId = 'measurement_date';
                } else if (this.employer.position_id === 7) {
                    sort[0].colId = 'installation_date';
                }
            }

            return sort;
        },
        employerId() {
            return this.$store.state.auth.employerId;
        }
    },
    methods: {
        async getEmployer() {
            try {
                const response = await this.$store.dispatch('employers/getEmployer', this.employerId);
                this.employer = response.data.data;
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
                if (this.employer) {
                    this.getDataFromServer();
                }
            }
        },
        getDataFromServer() {
            const requestParams = {
                size: this.pageModel.pageSize,
                page: this.pageModel.currentPage,
                sort: this.sortModel,
                filter: this.filterModel
            };
            this.loading = true;
            this.$store.dispatch('deals/getPaginatedList', requestParams).then(
                response => {
                    this.pageModel.pageSize = +response.data.meta.per_page;
                    this.pageModel.currentPage = response.data.meta.current_page;
                    this.unreadDeals = response.data.meta.unread;
                    this.saveSetting();
                    this.loading = false;
                }).catch(
                error => {
                    console.log(error);
                });
        },
        getFilterTitle(data) {
            this.filterTitle = data;
        },
        setSettings() {
            let settings;

            if (!this.setting || !this.setting.deals) {
                settings = this.defaultSettings.deals;
            } else {
                settings = this.setting.deals;
            }

            this.filterModel = JSON.parse(JSON.stringify(settings.filter));
            this.pageModel = JSON.parse(JSON.stringify(settings.page));
            this.columnsModel = JSON.parse(JSON.stringify(settings.table));

            this.setColumnsList(this.columnsModel);
            this.saveSetting();
        },
        getCurrentPage(page) {
            this.pageModel.currentPage = page;
            this.getDataFromServer();
            this.scrollToTop();
        },
        filterApplied(filter) {
            this.filterModel = filter;
            this.pageModel.currentPage = 1;
            this.saveSetting(undefined, filter).then(
                () => {
                    this.setSettings();
                }).catch(
                error => {
                    console.log(error);
                });
            this.getDataFromServer();
        },
        goToDeal(id) {
            const route = {
                name: 'deal-card',
                params: { id: id }
            };

            this.$router.push(route);
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        setColumnsList(columnSettings) {
            columnSettings.forEach((item) => {
                const colName = item.colId;
                if (Object.prototype.hasOwnProperty.call(this.attributes, colName)) {
                    this.attributes[colName].hide = item.hide;
                }
            });
        },
        booleanFormat(value) {
            if (!value) return '';
            value = Boolean(value);
            if (value === true) {
                return 'Да';
            } else if (value === false) {
                return 'Нет';
            }
        },
        async saveSetting(table = this.columnsModel, filter = this.filterModel) {
            const data = {
                'deals': {
                    'table': table,
                    'sort': this.sortModel,
                    'filter': filter,
                    'page': this.pageModel
                }
            };

            await this.$store.dispatch('preferences/setPreferences', data);
        }
    },
    mounted() {
        this.getEmployer();
        this.$store.dispatch('preferences/getPreferences').then(
            () => {
                this.setSettings();
            }).catch(
            error => {
                console.log(error);
            });
    },
    created() {
        eventBus.$on('hideColumnSettings', () => {
            this.columnSettingsShow = false;
            this.scrollToTop();
        });
        eventBus.$on('hideFilterSettings', () => {
            this.filterSettingsShow = false;
            this.scrollToTop();
        });
        eventBus.$on('newColumnSettings', table => {
            this.saveSetting(table).then(
                () => {
                    this.setSettings();
                }).catch(
                error => {
                    console.log(error);
                });
        });

        Object.keys(this.attributes).forEach((item) => {
            if (!this.attributes[item].notGridColumn) {
                this.columnDefs.push({ headerName: '', field: item });
            }
        });
    }
};
</script>
